import { render } from "./contrats.vue?vue&type=template&id=7554a4de"
import script from "./contrats.vue?vue&type=script&lang=ts"
export * from "./contrats.vue?vue&type=script&lang=ts"
script.render = render

export default script